export var Shadow;
(function (Shadow) {
  Shadow["SMALL"] = "0 1px 3px rgba(0, 0, 0, 0.1), 0 0 2px rgba(0, 0, 0, 0.05)";
  Shadow["REGULAR"] = "0 4px 6px rgba(0, 0, 0, 0.06), 0 0 4px rgba(0, 0, 0, 0.06)";
  Shadow["LARGE"] = "0 0 6px rgba(0, 0, 0, 0.06), 0 10px 16px rgba(0, 0, 0, 0.1);";
})(Shadow || (Shadow = {}));